<template>
    <div>
        <div class="text-left primary white--text pl-2 py-2 text-uppercase" style="font-size: 0.875rem; font-weight: 500">{{ barLabel }}</div>
        <highcharts :options="options"></highcharts>
    </div>
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
    props: {
        barLabel: {
            type: String,
            required: true,
        },
        data: {
            type: Array,
            required: true
        },
        centerTextComputation: {
            type: Function,
            required: false,
            default: function (data, valueKey = 'y') {
                return this.$options.filters.money(data.reduce((sum, item) => {
                    return sum + item[valueKey];
                }, 0));
            }
        },
        valueComputation: {
            type: Function,
            required: false,
            default: function (items = []) {
                return items.reduce(function (sum, item) {
                    return Math.round((sum + item.accountsOverviewValue) * 100 ) / 100
                }, 0)
            }
        }
    },

    components: {
        highcharts: Chart
    },

    computed: {
        highchartData() {
            return this.data.map((d) => {
                return {
                    name: d.type,
                    color: d.color,
                    y: this.valueComputation(d.items)
                }
            })
        },
        title() {
            if (this.centerTextComputation) {
                return this.centerTextComputation(this.highchartData);
            }

            return ''
        },
        options() {
            return {
                chart: {
                    type: 'pie',
                },
                title: {
                    text: this.title,
                    align: 'center',
                    x: -50,
                    verticalAlign: 'middle',
                },
                plotOptions: {
                    pie: {
                        showInLegend: true,
                        shadow: false,
                        center: ['50%', '50%'],
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                tooltip: {
                    valuePrefix: '$'
                },
                series: [
                    {
                        name: 'Value',
                        innerSize: '80%',
                        data: this.highchartData
                    }
                ],
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemMarginTop: 10,
                    itemMarginBottom: 10
                }
            }
        }
    }
}
</script>
